import React from "react";
import BackgroundImage from "gatsby-background-image";
import styled from "styled-components";
import { graphql, useStaticQuery } from "gatsby";

import Layout from "components/common/layouts/Main";
import { getImages } from "utils/images";
import Share from "./Share";

const Container = styled(BackgroundImage)`
  border-radius: 8px;
  max-width: 1248px;
  width: 100%;
  margin: auto;
  min-height: 760px;
  overflow: hidden;
  color: #fff;

  font-size: 28px;
  line-height: 42px;
  letter-spacing: -0.01em;
  padding: 38px 64px;

  display: flex;
`;

const LeftWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${(props) => props.width || "auto"};
`;

const RightWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props.alignContent};
`;

export default function Slides({ children }) {
  const data = useStaticQuery(graphql`
    query {
      background: file(relativePath: { eq: "slides-background.png" }) {
        base
        childImageSharp {
          fluid(maxWidth: 1248, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  const images = getImages(data);

  return (
    <Layout color="#0b1030">
      <Container {...images.getFile("background")}>{children}</Container>
    </Layout>
  );
}

function LeftSide({ children, width }) {
  return (
    <LeftWrap width={width}>
      {children}
      <Share />
    </LeftWrap>
  );
}

function RightSide({ children, alignContent = "space-between" }) {
  return <RightWrap alignContent={alignContent}>{children}</RightWrap>;
}

Slides.Left = LeftSide;
Slides.Right = RightSide;
